import React, { Component } from "react";

import {
  Table,
  Header,
  HeadCell,
  YellowCell,
  WhiteCell,
  SeashellCell,
  TableContainer,
  BoldText
} from "../shared/styledComponents";

class DocumentManagementDashboardContent extends Component {
  state = {
    isLoading: true,
    documentManagementData: []
  };

  componentDidMount = () => {
    this.setState({
      isLoading: false,
      documentManagementData: [
        {
          name: "DOCX Copy of the PDF",
          totalJobs: 54,
          jobsDelivered: 32
        },
        {
          name: "Electronic Signing",
          totalJobs: "-",
          jobsDelivered: "-"
        }
      ]
    });
  };
  render() {
    return (
      <div>
        <TableContainer>
          <BoldText>Document Management</BoldText>
          <Table>
            <Header>
              <tr>
                <HeadCell />
                <HeadCell>Total Jobs</HeadCell>
                <HeadCell>Jobs Delivered</HeadCell>
              </tr>
            </Header>
            <tbody>
              {this.state.documentManagementData.map((items, index) => {
                return (
                  <tr key={index} style={{ cursor: "pointer" }}>
                    <YellowCell>{items.name}</YellowCell>
                    <WhiteCell>{items.totalJobs}</WhiteCell>
                    <SeashellCell>{items.jobsDelivered}</SeashellCell>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

export default DocumentManagementDashboardContent;
